import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    // 加密
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data,
    withCredentials: true
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取微信登录二维码
export function getWechatLoginQrCode() {
  return request({
    url: '/admin/wechat/qrcode',
    method: 'get'
  })
}

// 轮询微信扫码状态
export function checkWechatLoginStatus(ticket) {
  return request({
    url: '/admin/wechat/status',
    method: 'get',
    params: { ticket }
  })
}

export function getAdminInfo() {
  return request({
    url: '/admin/info',
    method: 'get'
  });
}

export function updatePassword(data) {
  return request({
    url: '/admin/updatePassword',
    method: 'post',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/login.js